import {useMemo} from 'react';

export function useOnce<T>(fn: () => T): T {
    // we want to execute fragment of code once and...
    // current implementation of useMemo() is sufficient so...
    // eslint-disable-next-line
    return useMemo<T>(fn, []);
}
